import React, { useState, lazy, Suspense } from "react";
import { Headers } from "../../layouts/headers/headers";
import { MainContent } from "../../layouts/MainContent";
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { ActividadeList } from "../../components/datatable/ActividadeList";

import { MdAddCircleOutline } from "react-icons/md";

// Lazy load de modales
const UserModal = lazy(() => import("../../components/modals/profileUser"));
const AggActivity = lazy(() => import("../../components/modals/aggActivity"));
const DeleteActivity = lazy(() => import("../../components/modals/deleteActivity"));
const ResetActivity = lazy(() => import("../../components/modals/resetActivity"));

const Activity = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const handleRefresh = () => setRefresh(prev => !prev);

  const openModal = (modalType, activity = null) => {
    setSelectedActivity(activity);
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setSelectedActivity(null);
    setActiveModal(null);
  };

  return (
    <div className="flex h-screen">
      <Headers />
      <MainContent>
        <HeadersCentral showDropdown={showDropdown} setShowDropdown={setShowDropdown} openModal={() => openModal("user")} />

        <main className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
              🛠️ Panel de Actividades
            </h1>
            <button
              className="flex items-center gap-2 bg-purple-600 hover:bg-purple-500 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition-all duration-200"
              onClick={() => openModal("add")}
            >
              <MdAddCircleOutline size={22} /> Nueva
            </button>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300">
            <ActividadeList
              categories={activities}
              setCategories={setActivities}
              openModal={openModal}
              refresh={refresh}
            />
          </div>
        </main>
      </MainContent>
      <Suspense fallback={null}>
        {activeModal === "user" && <UserModal isOpen={true} onClose={closeModal} />}
        {activeModal === "add" && (
          <AggActivity isOpen={true} onClose={closeModal} onSuccess={handleRefresh} />
        )}
        {activeModal === "delete" && (
          <DeleteActivity
            isOpen={true}
            onClose={closeModal}
            activite={selectedActivity}
            onSuccess={handleRefresh}
          />
        )}
        {activeModal === "data" && (
          <ResetActivity
            isOpen={true}
            onClose={closeModal}
            activite={selectedActivity}
            onSuccess={handleRefresh}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Activity;
